function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 15.5,
  fill: "white",
  stroke: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4667 10.6611C11.9831 10.6611 11.5192 10.8532 11.1772 11.1952C10.8351 11.5372 10.643 12.0011 10.643 12.4848V19.5333C10.643 20.017 10.8351 20.4808 11.1772 20.8229C11.5192 21.1649 11.9831 21.357 12.4667 21.357H19.5152C19.9989 21.357 20.4628 21.1649 20.8048 20.8229C21.1468 20.4808 21.3389 20.017 21.3389 19.5333V16.009C21.3389 15.5553 21.7067 15.1875 22.1604 15.1875C22.6141 15.1875 22.9819 15.5553 22.9819 16.009V19.5333C22.9819 20.4527 22.6167 21.3345 21.9666 21.9846C21.3164 22.6348 20.4347 23 19.5152 23H12.4667C11.5473 23 10.6655 22.6348 10.0154 21.9846C9.36524 21.3345 9 20.4527 9 19.5333V12.4848C9 11.5654 9.36524 10.6836 10.0154 10.0334C10.6655 9.38331 11.5473 9.01807 12.4667 9.01807H15.991C16.4447 9.01807 16.8125 9.38586 16.8125 9.83957C16.8125 10.2933 16.4447 10.6611 15.991 10.6611H12.4667Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5125 10.648C19.1917 10.3272 19.1917 9.80704 19.5125 9.48622L21.4178 7.5809C21.7387 7.26008 22.2588 7.26008 22.5796 7.5809L24.421 9.42232C24.7419 9.74314 24.7419 10.2633 24.421 10.5841L22.5157 12.4894C22.1949 12.8102 21.6748 12.8102 21.3539 12.4894L19.5125 10.648ZM21.2552 10.0671L21.9348 10.7467L22.6784 10.0032L21.9987 9.32357L21.2552 10.0671Z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5184 9.48806C19.8394 9.16787 20.359 9.16816 20.6796 9.48872L22.5197 11.3289C22.8405 11.6497 22.8405 12.1698 22.5197 12.4907L18.8805 16.1299C18.7291 16.2813 18.5245 16.3676 18.3104 16.3704L16.4456 16.3951C16.224 16.398 16.0106 16.3113 15.8539 16.1546C15.6972 15.9979 15.6104 15.7845 15.6134 15.5629L15.638 13.6898C15.6408 13.4754 15.7274 13.2706 15.8792 13.1191L19.5184 9.48806ZM17.2765 14.0459L17.2673 14.7411L17.9548 14.732L20.7771 11.9098L20.098 11.2307L17.2765 14.0459Z",
  fill: "#6F62FF"
});

var SvgLinkCircle = function SvgLinkCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkCircle.f600970a.svg";
export { ForwardRef as ReactComponent };